module.exports = __webpack_public_path__ + "src/assets/img/illustrations/confetti.77129858d9faeadf3e1698e68a70ba72.png";